import { cookieAxios } from "../../../interceptors/cookieAxios";

// Surface the backend's actual reason (error.response.data.error) instead of the
// bare axios "Request failed with status code 4xx" message, and always return a
// { success:false, error } object so callers can render the reason.
const toError = (error) => {
  const reason =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong";
  return { success: false, error: reason };
};

class LeadService {
  createLead = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/user/create-lead`,
      data: formData,
    })
      .then((response) => response.data)
      .catch(toError);
  };

  // Minimal phone lookup for the Add-Lead form (existence + ownership state).
  lookupLead = async (phone) => {
    return cookieAxios({
      method: "get",
      url: `/user/lead-lookup?phone=${encodeURIComponent(phone)}`,
    })
      .then((response) => response.data)
      .catch(toError);
  };

  // Take ownership of a claimable (stale / shared / closed) lead.
  claimLead = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/user/claim-lead`,
      data: formData,
    })
      .then((response) => response.data)
      .catch(toError);
  };

  getLeads = async (leadType) => {
    return cookieAxios({
      method: "get",
      url: `/user/get-leads?lead_type=${leadType}`,
    })
      .then((response) => response.data)
      .catch(toError);
  };

  updateLead = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/user/update-lead`,
      data: formData,
    })
      .then((response) => response.data)
      .catch(toError);
  };

  getComments = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/user/get-comments`,
      data: formData,
    })
      .then((response) => response.data)
      .catch(toError);
  };

  revealLeadPhone = async (leadId) => {
    return cookieAxios({
      method: "get",
      url: `/user/reveal-lead-phone?lead_id=${encodeURIComponent(leadId)}`,
    })
      .then((response) => response.data)
      .catch(toError);
  };

  getLeadsCount = async () => {
    return cookieAxios({
      method: "get",
      url: `/user/get-leads-count`,
    })
      .then((response) => response.data)
      .catch(toError);
  };
}

const leadService = new LeadService();

export default leadService;
